import { type BankOption, useSbpBanks } from '@/features/withdraw-sbp';
import { useMemo } from 'react';

export function useBankOptions(paymentTypeCode: string) {
  const { banksData, isBanksLoading, isBanksError, banksError } =
    useSbpBanks(paymentTypeCode);

  const bankOptions = useMemo<BankOption[]>(() => {
    if (!banksData) return [];
    return (banksData.banks || []).map(bank => ({
      id: bank.bankId,
      name: bank.bankName,
    }));
  }, [banksData]);

  return {
    isBanksLoading,
    bankOptions,
    isBanksError,
    banksError,
  };
}
